<template>
  <div class="dashboard">
    <breadcrumbs :crumbs="['Organization Dashboard']">
            <span v-if="!loading && user.access > 2" class="pull-right options-gear margin-right-10 margin-top-10" @click.prevent="showEditWidgetsModal"><i
                class="icon-settings right"></i></span>
    </breadcrumbs>
    <div class="row" v-if="!loading">
      <div class="col-md-12 db-column" id="first-column">
        <div class="row">
          <widget :name="widgets.widgetsFirst" draggable=".dragme" :type="'widgetsFirst'"
                  v-on:passWidgets="widgetsData"></widget>
        </div>
      </div>
      <div class="col-md-12 db-column" id="second-column">
        <div class="row">
          <widget :name="widgets.widgetsSecond" draggable=".dragme" :type="'widgetsSecond'"
                  v-on:passWidgets="widgetsData"></widget>
        </div>
      </div>
    </div>
    <spinner v-else></spinner>

    <edit-widgets-modal
      v-model="showEditModal"
      :widgets="enabledWidgetsMap"
      @save="widgetsSaved"
    />
  </div>

</template>

<script>
  import {HTTP, ERROR} from '@/http-common';
  import draggable from 'vuedraggable';
  import Widget from '@/components/widgets/Widget.vue';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import EditWidgetsModal from '@/components/modals/EditWidgetsModal';
  import {mapActions, mapGetters} from 'vuex';
  import Spinner from '@/components/Spinner';
  import _ from 'lodash';

  export default {
    name: 'dashboard',
    components: {
      draggable,
      Spinner,
      Widget,
      EditWidgetsModal,
      Breadcrumbs
    },
    data() {
      return {
        widgetsOrganization: {
          widgetsFirst: [{
            "id": "2",
            "name": "ActivityFeed"
          }, {
            "id": "1",
            "name": "CaseloadSummary"
          }, {
            "id": "4",
            "name": "TopReports"
          }],
          widgetsSecond: []
        },
        portlet: '',
        showEditModal: false,
      }
    },
    beforeMount() {
      this.getDashboard();
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        loading: 'getLoading',
        organizationDashboard: 'getOrganizationDashboard'
      }),
      widgets() {
        if (this.user['organization_widgets'] == null)
          return this.widgetsOrganization;
        return this.user['organization_widgets'];
      },
      enabledWidgetsMap() {
        const allWidgets = this.widgets['widgetsFirst'].concat(this.widgets['widgetsSecond']);
        const results = {};
        if (this.organizationDashboard.all_widgets){
          this.organizationDashboard.all_widgets.map(widget => {
            results[widget.name] = allWidgets.find(item => item.name === widget.name) !== undefined;
          })
        }
        return results;
      }
    },
    methods: {
      ...mapActions({
        getDashboard: 'loadOrganizationDashboard'
      }),
      widgetsData(data) {
        if (data[0] === 'widgetsFirst') {
          this.widgets.widgetsFirst = data['1'];
        } else {
          this.widgets.widgetsSecond = data['1'];
        }

        this.saveData();
      },
      showEditWidgetsModal() {
        this.showEditModal = true;
      },
      widgetsSaved(widgetsEnabled) {
        const currentWidgets = new Set();
        ['widgetsFirst', 'widgetsSecond'].map(rowName => {
          this.widgets[rowName] = this.widgets[rowName].filter(item => {
            currentWidgets.add(item.name);
            return widgetsEnabled[item.name];
          });
        })

        this.organizationDashboard.all_widgets.map(widget => {
          if (widgetsEnabled[widget.name] && !currentWidgets.has(widget.name)) {
            this.widgets.widgetsFirst.push({
              'name': widget.name,
              'id': widget.id
            })
          }
        })

        HTTP.post(`organization/widgets`, {id: this.user.organizations[0].id, value: this.widgets})
          .then(response => {
            ERROR(response);
            this.getDashboard();
          })
          .catch(err => {
            console.log(err);
          })
      },
      saveData: _.debounce(
        function () {
          HTTP.post(`organization/widgets`, {id: this.user.organizations[0].id, value: this.widgets})
            .then(response => {
              ERROR(response);
            })
            .catch(err => {
              console.log(err);
            });
        }, 50)
    },
  }
</script>
<style scoped>
  .flip-list-move {
    transition: transform 0.5s;
  }

  .db-column > .row > div, .db-column > div > span {
    min-height: 30vh;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// DashboardOrganization.vue?71a78fa6